function initNewsletterForm() {
	
   $('.newsletter-form').validate({
        submitHandler: function() {	
            var data = $('.newsletter-form').serialize();
            var object = {
                'success': function (response){
					$('.newsletter-form .form-response').removeClass('success');
					$('.newsletter-form .form-response').removeClass('error');
					$('.newsletter-form .form-response').removeClass('show');

                    if(response['status']=='ok'){
						$('.newsletter-form .form-response').addClass('success').addClass('show').html(response['message']);			
                    }else{
						$('.newsletter-form .form-response').addClass('error').addClass('show').html(response['error']);
                    }
                },
                'data' : data
            };
            $.ajax(object);
            return false;
        },
        errorPlacement: function(error, element) {
           // error.hide();
        },
        highlight: function (element, errorClass, validClass) {
			/*$(element).parent().find('.form-control-feedback').remove();
			$(element).closest('.form-group').append('<span class=" form-control-feedback"><i class="fa fa-exclamation-triangle"></i></span>');
			$(element).parent().addClass('has-error has-feedback');*/
        },
        unhighlight: function (element, errorClass, validClass) {
            /*$(element).parent().find('.form-control-feedback').remove();
            $(element).parent().removeClass('has-error has-feedback');*/
        }
    });
}
function updateCartForm2(){
    $('form[name="cart-update-qty"]').on('submit',function(){
        $.ajax({data:$(this).serialize(),success:function(data){
            if(data.status === 'ok'){
                form_submit_response('form[name="cart-update-qty"]','success',data.message,true);

            }else if(data.status === 'error') {
                form_submit_response('form[name="cart-update-qty"]','error',data.error);
            }else{
                form_submit_response('form[name="cart-update-qty"]','error','An unknown error occured. Please try again later');
            }
        }});
        return false;
    });
}
function confirm_overwrite(message, callback) {
    var c = confirm(message);
    if (c) {
        callback();
    }
}
$(document).on('click', '.delete-address', function () {
	var id = $(this).data('id');
	confirm_overwrite('Are you sure you want to remove that address?', function () {
		$.ajax({data: {module: 'addresses', 'action': 'del-address', id: id}, success: function (data) {
			if (data.status === 'ok') {
				form_submit_response('.my_account_content', 'success', data.message, true);
			} else if (data.status === 'error') {
				form_submit_response('.my_account_content', 'error', data.error);
			} else {
				form_submit_response('.my_account_content', 'error', 'An unknown error occurred. Please try again later');
			}
		}
		});
	}, 'OK');
});
function addressForm() {

    $('form[name="address-form"]').validate({
        submitHandler: function () {
            $.ajax({data: $('form[name="address-form"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                     window.location.reload();
					form_submit_response('form[name="address-form"]', 'success', data.message, true);
                } else if (data.status === 'error') {
                    form_submit_response('form[name="address-form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="address-form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
	$('#country').on('change',function(){
		if($(this).val()==1 || $(this).val()==2){
			$('.state-dropdown').show();
			$('.state-dropdown option[data-country="'+$(this).val()+'"]').show();
			$('.state-dropdown option[data-country!="'+$(this).val()+'"]').hide();
		}else{
			$('.state-dropdown').hide();
		}
	})
}
function registerForm() {

    target = "form[name='register_form']";

    $(target).off('keydown');

    $(target).on('keydown',function(e){
        switch(true){
            case e.keyCode == 13: // ENTER
                $(target).submit();
                return false;
                break;
        }
    });

    $(target).validate({
        rules: {
            'name': 'required',
            'surname': 'required',
            'email': {
                required: true,
                email: true
            },
            'password': {
                required: true
            },
            'captcha_code': 'required'
        },
        messages: {
            'name': 'Required',
            'surname': 'Required',
            'email': 'Required',
            'password': 'Required',
            'captcha_code': 'Required'
        },

        submitHandler: function (e) {

            $('body').prepend('<div class="loading blocking text-center"><span>PROCESSING REQUEST</span></div>');
            $.ajax({data: $(target).serialize(), success: function (data) {
                $('.loading').remove();
                if (data.status === 'ok') {

                    if(typeof registerTimeout !== "undefined" && registerTimeout!=null){
                        clearTimeout(registerTimeout);
                    }

                    if(data.redirect){
                        //form_submit_response(target, 'success', data.message);
                        //setTimeout(function(){
                            window.location = data.redirect;
                        //},5000);

                    }else{
                        form_submit_response(target, 'success', data.message, true);
                    }

                } else if (data.status === 'error') {
                    if(data.error_code == 100){
                        openAjaxModal(URL  + 'ajax/customer:login-sso/'+$(target).find('input[name="email"]').val()+'/');
                    }else{
                        form_submit_response(target, 'error', data.error);
                    }
                } else {
                    form_submit_response(target, 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}
function loginForm() {

    $('form[name="login_form"]').on('keydown',function(e){
        switch(true){
            case e.keyCode == 13: // ENTER
                $('form[name="login_form"]').submit();
                break;
        }
    });

    $('form[name="login_form"]').addClass('ready');
    $('form[name="login_form"]').validate({
        rules: {
            'email': 'required',
            'password': 'required'
        },
        messages: {
            'email': 'Required',
            'password': 'Required'
        },
        submitHandler: function () {
            $.ajax({data: $('form[name="login_form"]').serialize(), success: function (data) {
                if (data.status === 'ok'  && typeof(data.redirect) !== 'undefined') {
                    //var hash = getHash();
                    window.location.reload();
                    if(registerTimeout!=null){
                        clearTimeout(registerTimeout);
                    }
                }else if (data.status === 'ok'){
                    window.location.reload();
                    if(registerTimeout!=null){
                        clearTimeout(registerTimeout);
                    }
                }else if (data.status === 'error') {
                    if (typeof(data.callback) !== 'undefined') {
                        var email = $('form[name="login_form"] input[name="email"]').val();
                        eval(data.callback + '("' + data.error + '","' + email + '")');
                    } else {
                        form_submit_response('form[name="login_form"]', 'error', data.error);
                    }
                } else {
                    form_submit_response('form[name="login_form"]', 'error', 'An unknown error occurred. Please try again later');
                }

            }});
        }
    });
}

function contactForm() {	
	
    $('form[name="contact-form"]').validate({	
        submitHandler: function () {
            $.ajax({data: $('form[name="contact-form"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                    alert(data.message);
					$('.close-btn').trigger('click');
					//form_submit_response('form[name="contact-form"]', 'success', data.message, true);
					
                } else if (data.status === 'error') {
                    form_submit_response('form[name="contact-form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="contact-form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}
function contactFormSchool() {

    $('form[name="contact-form"]').validate({

        submitHandler: function () {
            $.ajax({data: $('form[name="contact-form"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                    alert(data.message);
					$('.close-btn').trigger('click');

                } else if (data.status === 'error') {
                    form_submit_response('form[name="contact-form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="contact-form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}
function contactFormSponsor() {

    $('form[name="contact-form"]').validate({

        submitHandler: function () {
            $.ajax({data: $('form[name="contact-form"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                    alert(data.message);
					$('.close-btn').trigger('click');

                } else if (data.status === 'error') {
                    form_submit_response('form[name="contact-form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="contact-form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}
function contactFormVolunteer() {
    $('form[name="volunteers-form"]').validate({

        submitHandler: function () {
            $.ajax({data: $('form[name="volunteers-form"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                    alert(data.message);
					$('.close-btn').trigger('click');

                } else if (data.status === 'error') {
                    form_submit_response('form[name="volunteers-form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="volunteers-form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}

function donateNeedForm() {
	
    $('form[name="donate_need"]').validate({

        submitHandler: function () {
            $.ajax({data: $('form[name="donate_need"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                    alert(data.message);
					$('.close-btn').trigger('click');

                } else if (data.status === 'error') {
                    form_submit_response('form[name="donate_need"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="donate_need"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        } 
    });
}

function CFDonateForm() {

	var $the_form = $('form[name="donate_cause"]');    
    var $amount = $the_form.find('input[name="amount"]');

    $amount.change(function(){
        $('.donate-form .c-total').html($amount.val());
    });    
    
    

    $the_form.validate({
        submitHandler: function () {
            $the_form.addClass('confirm');
            var form_data = $the_form.serialize();

            var link = SITE_URL+'/ajax/crowdfunding:confirmation-summary/?'+form_data;          

            $( '.checkout-confirm' ).load( link, function() {   
                $the_form.find('.cancel-btn').click(function(){
                    $the_form.removeClass('confirm');
                });
                
                $the_form.find('.donate-btn').click(function(){ 
                    $the_form.find('.donate-btn').addClass('disabled');
                    $the_form.addClass('loading');
                    $.ajax({
                        data: form_data, 
                        success: function (data) {
                            if(data.hasOwnProperty("returncode") && data.returncode == "REDIRECT"){
                                window.location = data.location;
                            }else if (data.status === 'BILLED') {                                   
                                $the_form.closest('.modal').modal('hide');
                                form_submit_response('form[name="donate_cause"]', 'error', data.status);

                            } else if (data.status === 'error') {
                                form_submit_response('form[name="donate_cause"]', 'error', data.error);
                            } else {
                                form_submit_response('form[name="donate_cause"]', 'error', 'An unknown error occurred. Please try again later');
                            }
                        }
                    });
                });      
            });            


                     
        }
    });
}

function donateMyDayForm() {
	
    $('form[name="donate_my_day"]').validate({

        submitHandler: function () {
            $.ajax({data: $('form[name="donate_my_day"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                    alert(data.message);
					$('.close-btn').trigger('click');

                } else if (data.status === 'error') {
                    form_submit_response('form[name="donate_my_day"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="donate_my_day"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}

function donateCrowdfundingActionForm() {
	
    $('form[name="donate_crowdfunding_action_form"]').validate({

        submitHandler: function () {
            $.ajax({data: $('form[name="donate_crowdfunding_action_form"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                    alert(data.message);
					$('.close-btn').trigger('click');

                } else if (data.status === 'error') {
                    form_submit_response('form[name="donate_crowdfunding_action_form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="donate_crowdfunding_action_form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}
function createCrowdfundingActionForm() {
    
    $('form[name="create_crowdfunding_action"]').validate({

        submitHandler: function () {
            $.ajax({data: $('form[name="create_crowdfunding_action"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                    $('.close-btn').trigger('click');
                    location.reload(); 
                } else if (data.status === 'error') {
                    form_submit_response('form[name="create_crowdfunding_action"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="create_crowdfunding_action"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}

function crowdfundingDonateMyDayForm() {
    
    $('form[name="crowdfunding_donate_mday"]').validate({

        submitHandler: function () {
            $.ajax({data: $('form[name="crowdfunding_donate_mday"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                    $('.close-btn').trigger('click');
                    location.reload(); 
                } else if (data.status === 'error') {
                    form_submit_response('form[name="crowdfunding_donate_mday"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="crowdfunding_donate_mday"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
} 

function forgotPasswordForm() {

    var target = 'form[name="forgot_password_form"]';
   
    $('form[name="forgot_password_form"]').addClass('ready');
    $('form[name="forgot_password_form"]').validate({
        rules: {
            'email': 'required'
        },
        messages: {
            'email': 'Required'
        },
        submitHandler: function () {
                        
            $.ajax({data: $('form[name="forgot_password_form"]').serialize(), success: function (data) {
                if (data.status == 'ok') {
                    $('form[name="forgot_password_form"] .form-submitted').removeClass('hidden');
                    $('form[name="forgot_password_form"] input:text').data('email',$('form[name="forgot_password_form"] input:text').val());
                    $('form[name="forgot_password_form"] input:text').val('');
                    $('form[name="forgot_password_form"] input:text').closest('.row').hide();
                } else if (data.status == 'error') {
                    form_submit_response('form[name="forgot_password_form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="forgot_password_form"]', 'error', 'An unknown error occurred. Please try again later');
                }

            }});
        }
    });
}


function resend_activation_email(message, email) {
    message += '\nResend activation email?';
    var r = confirm(message);
    if (r == true) {
        $.ajax({data: {module: 'customers', 'action': 'send-activation-email', email: email}, success: function (data) {
            if (data.status == 'ok') {
                form_submit_response('', 'success', 'Activation email succesfully sent', true);
            } else if (data.status == 'error') {
                form_submit_response('form[name="login_form"]', 'error', data.error);
            } else {
                form_submit_response('form[name="login_form"]', 'error', 'An unknown error occurred. Please try again later');
            }

        }});
    }


}


function resetPasswordForm() {
    var target = 'form[name="reset_password_form"]';
   
    $('form[name="reset_password_form"]').addClass('ready');
    $('form[name="reset_password_form"]').validate({
        rules: {
            password: {
                required: true,
                minlength: 6
            },
            password_verify: {
                minlength: 6,
                equalTo: "#password"
            },
            email: {
                required: true,
                email: true
            }
        },
        messages: {
            'email': 'Required',
            'password': 'Required',
            'password_verify': 'Required'
        },
        submitHandler: function () {
          
            $.ajax({data: $('form[name="reset_password_form"]').serialize(), success: function (data) {
                if (data.status == 'ok') {

                    var email = $('form[name="reset_password_form"] input[name="email"]').val();
                    setTimeout(function(){
                        window.location = URL;
                    },5000);
                    $('form[name="reset_password_form"] input:text').val('');
                    $('form[name="reset_password_form"] input:password').val('');
                    form_submit_response('form[name="reset_password_form"]', 'success', data.message);
                } else if (data.status == 'error') {
                    form_submit_response('form[name="reset_password_form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="reset_password_form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}


function addToCartForm() {
    $(document).on('submit','form[name="product_addtocart_form"]',function(){
        var form = $(this);
        $.ajax({data: $(this).serialize(), success: function (data) {
            if (data.status === 'ok') {
                var cart_counter = $('.cart-counter');
                if(data.total === 0){
                    cart_counter.removeClass('label-danger').addClass('label-default');
                }else{
                    cart_counter.addClass('label-danger').removeClass('label-default');
                }
                $('.cart-totals').html(data.total_amount);
                cart_counter.html(data.total);

                ajaxContent('.ajax-content');

                if(data.callback_function){
                    setTimeout(function(){
                        try{
                            window[data.callback_function]();
                        }catch (Error){ }

                    },500);
                }

                blinkCart();
				if(!$('body').hasClass('show-mini-cart')){
					$('body').addClass('show-mini-cart');
				}
				
            } else if (data.status === 'error') {
                form_submit_response('#messages_product_view', 'error', data.error);
            } else {
                form_submit_response('#messages_product_view', 'error', 'An unknown error occurred. Please try again later');
            }

            form.closest('.modal').modal('hide');

        }});

        return false;
    });
}




